<template>
    <el-upload class="x-upload"
        :data="data"
        :name="name"
        :action="action"
        :accept="accept"
        :auto-upload="autoUpload"
        :show-file-list="false"
        :before-upload="beforeUploadHook"
        :on-progress="onProgress"
        :on-success="onSuccess"
        :on-change="onChange"
        :on-error="onError"
    >
        <el-button type="text"
            :loading="loading"
            :disabled="loading"
        >
            {{ label }}
        </el-button>
    </el-upload>
</template>

<script>
export default {
    name: 'XUpload',

    props: {
        data: Object,
        label: {
            type: String,
            default: '点击上传'
        },
        name: String,
        action: {
            type: String,
            required: true
        },
        autoUpload: {
            type: Boolean,
            default: true
        },
        accept: String,
        beforeUpload: Function
    },

    data() {
        return {
            loading: false
        }
    },

    methods: {
        beforeUploadHook(file) {
            if (this.beforeUpload) {
                return this.beforeUpload(file)
            }
            return true
        },
        onChange(file, fileList) {
            this.$emit('change', file, fileList)
        },
        onProgress() {
            this.loading = true
        },
        onSuccess(res, file, fileList) {
            this.$emit('success', res, file, fileList)
            this.loading = false
        },
        onError(err, file, fileList) {
            this.$emit('error', err, file, fileList)
            this.loading = false
        }
    }
}
</script>

<style lang="less" scoped>
    .x-upload {
        margin-right: 10px;
        display: inline;
    }
</style>
